var _rect, _rect2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.952936,
    height: 12.57213,
    rx: 1,
    ry: 1,
    transform: "matrix(.957236 0 0 1.144012 3.236346 0.808666)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.952936,
    height: 12.57213,
    rx: 1,
    ry: 1,
    transform: "matrix(.733553 0 0 0.810675 4.349497 2.085544)",
    fill: "none",
    stroke: "#000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -1.014938,
    y1: 0,
    x2: 0.485062,
    y2: 0,
    transform: "matrix(1.309959 0 0 1 8.347058 13.783506)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.aff7926a53e42302c763b458bf0be6be.svg";
export { ForwardRef as ReactComponent };